import React from 'react';
import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';

// Showing a skeleton placeholder for a video player
export const PlaceholderVideo = () => {
  const {
    theme: { colors },
  } = useRagnar();

  return (
    <Box
      data-testid="placeholder-video"
      width="100%"
      flex="1 1 auto"
      justifyContent="center"
      alignItems="center"
      mb={3}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 442 296"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.978516"
          y="0.162048"
          width="441.018"
          height="295.081"
          rx="6.41481"
          fill={colors.neutralWeakest}
        />
        <path
          d="M191.018 109.214V185.39L259.977 147.302L191.018 109.214Z"
          fill={colors.neutral}
        />
      </svg>
    </Box>
  );
};
